export default __webpack_public_path__ + "168715c69b82f8c644c0ca6da34ac7da.svg";